/**
 * De overgangsknop (R5-LP, SB7): voor wie nog niet zover is om erbij te
 * komen. Hij zet een berichtje klaar voor de groepsapp met de link van de
 * voorpagina erachter. Het is een gewone wa.me-link (op de computer opent
 * die WhatsApp Web); op een aanraakscherm met navigator.share opent het
 * deelmenu van het toestel (utils/groepsapp.ts). Geen wachtlijst en geen backend: de uitnodiging is
 * het groeikanaal (domain/beta.server.ts). Staat op de voorpagina en in de
 * uitnodigingsstand van /signup; de vorm komt van de plek (className).
 */
import { deelOfWa, waHref } from '#app/utils/groepsapp.ts'
import { useT } from '#app/utils/i18n.tsx'
import { useOptionalRequestInfo } from '#app/utils/request-info.ts'
import { Icon } from './icons.tsx'

/** De link van de voorpagina: de origin van het verzoek (root-loader), op
 *  de server en in de browser dezelfde, dus geen verschil bij hydrateren. */
function useVoorpaginaUrl() {
	const origin = useOptionalRequestInfo()?.origin
	if (origin) return origin
	return typeof window === 'undefined' ? '' : window.location.origin
}

export function GroepsappKnop({
	className,
	testId,
}: {
	className: string
	testId?: string
}) {
	const t = useT()
	const url = useVoorpaginaUrl()
	const bericht = `${t('landing.groepsapp_tekst')} ${url}`
	const href = waHref(bericht)
	return (
		<a
			href={href}
			target="_blank"
			rel="noreferrer"
			className={className}
			data-testid={testId}
			onClick={(e) => deelOfWa(e, bericht, href)}
		>
			<Icon name="send" size={18} stroke={2.2} />
			{t('landing.cta_groepsapp')}
		</a>
	)
}
